import React from 'react';
import { Outlet } from "react-router-dom";
import { Helmet } from 'react-helmet'
import { AuthMiddleware } from "../../providers/AuthProvider";

const TalentSignupLayout = () => {
    //TODO check auth permissions
    return (
        <AuthMiddleware>
            <Helmet>
                <title>Register | Wripple</title>
            </Helmet>
            <Outlet />
        </AuthMiddleware>
    );
};

export default TalentSignupLayout;